<template>
    <div>
        <h1 class="pt-5">Populære produkter</h1>
        <v-slide-group show-arrows>
            <v-slide-item v-for="(product, i) in popularProducts" :key="i" v-slot:default="{ active, toggle }"
                class="mx-3 hover-zoom py-3" style="width: 270px; height: 426px; cursor: pointer">
                <B2CItemCard @clickButton="addBtnAction(product)" @clickCard="goToProductDetails(product)"
                    :id="product.idBase64" :title="product.title" type="P" :imageUrl="product.imgUrl"
                    :subtitle="product.brandName" :price="productPrice" :stockAmount="product.onlineStock"
                    :campaignValue="campaign && campaign.benefitRule === 2 ? 0 : discountPrice"
                    :campaignText="campaignText"></B2CItemCard>
            </v-slide-item>
        </v-slide-group>
    </div>
</template>
<script>
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import B2CItemCard from "@fixit/v-b2c-item/src/B2CItemCard.vue";


export default {
    mixins: [webshopMixins],
    props: {
        popularProducts: Array,
    },
    components: {
        B2CItemCard
    },
    data() {
        return {
            windowSize: { x: window.innerWidth, y: window.innerHeight },
        };
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight };
        },
        openSalonSelectDialog() {
            this.$store.dispatch("webshop/set", {
                key: "selectedProduct",
                value: this.product,
            });
            this.$store.dispatch("webshop/set", {
                key: "salonPickOptions",
                value: { dialog: true },
            });
        },
        addBtnAction(product) {
            this.$store.dispatch("webshop/set", {
                key: "addedToCartDialog",
                value: false,
            });
            if (this.salons.length === 1) {
                this.$store.dispatch("webshop/set", {
                    key: "selectedProduct",
                    value: product,
                });
                this.addProductToSalonCart(this.salons[0]);
            } else {
                this.openSalonSelectDialog();
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.VueCarousel-slide {
    padding: 10px;
}

.VueCarousel {
    max-width: 100%;
}

.action__buttons::v-deep {
    .v-btn {
        height: 42px !important;
    }
}

.product__description div {
    white-space: pre-wrap;
}

.v-skeleton-loader__heading {
    margin: 0 auto;
}
</style>
